import React from 'react'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'

const FormulaNotFound = () => (
  <section>
    <header>
      <PageTitle>
        Formula not found!
      </PageTitle>
    </header>
    <br/>
    <BackButton/>
  </section>
)

export default FormulaNotFound



// WEBPACK FOOTER //
// ./src/components/Formulas/FormulaNotFound.jsx